export default {
  title: {
    addCandidate: '添加求职者',
    editCandidate: '编辑求职者',
    step: {
      UPLOAD_RESUME: '上传简历',
      BASE_INFO: '基本信息',
      DUPLICATE_CANDIDATE: '重复候选人',
      EDUCATION: '教育背景',
      WORK_EXPERIENCE: '工作经验',
      LANGUAGE: '语言能力',
      DESCRIPTION: '求职者描述',
      ADDITIONAL_INFO: '附加信息',
      PRESCREEN_QUESTIONNAIRE: '申请人前置问卷',
      JOB_QUESTIONNAIRE: '申请人调查问卷',
      INVITE_QUESTIONNAIRE: '特定的问题',
      HR_QUESTIONNAIRE: '招聘人员筛选',
      ONBOARDING_QUESTIONNAIRE: '入职问卷答复',
      SUBMIT_REFERRAL: '提交/上传简历'
    },
    importResume: '导入简历',
    duplicateTitle: '重复候选人',
    history: '批量上传历史',
    uploader: '批量上传',
    baseInfo: '基础信息',
    education: '教育背景',
    language: '语言能力',
    additionalInfo: '附加信息',
    aiInterview: 'AI 面试',
    consent: '协议',
    workExperience: '工作经验',
    partTimeExperience: '实习 / 兼职经验',
    comment: '评论',
    appliedJobHistory: '申请工作记录',
    candidateActivity: '求职者行为',
    smartTags: '智能标签',
    manualTags: '手动标签',
    interviewManagement: '面试管理',
    interviewOverallRating: '面试评估总评',
    interviewRatingForm: '面试评估表',
    hiringManagerRating: '招聘经理评估',
    hrQuestionnaire: '招聘人员筛选',
    prescreenQuestionnaire: '申请人前置问卷',
    jobQuestionnaireResponse: '申请人调查问卷',
    specificQuestion: '特定的问题',
    assessmentScore: '测评得分',
    detailResume: '详细简历',
    addComment: '添加评论',
    onboardingQuestionnaire: '入职问卷',
    contact: '联系',
    groupRecord: '分组操作记录',
    preferenceQuestion: '偏好问卷答复',
    notification: '求职者职位提醒推送设置',
    inviteConsentTitle: '收集协议同意',
    aiResumeSummarizer: 'AI简历提炼 ',
    aiResumeMatchScore: 'AI匹配度',
    aiResumeMatchSummary: 'AI分析',
    aiResumeSummaryContent: 'AI简历提炼',
    aiResumeFitScore: 'AI匹配度',
    rateManagement: '简历评估管理',
    offerLetterSelectTemplate: '选择Offer模板',
    sendOfferLetter: '发放Offer',
    offerRecord: 'Offer记录',
    confirmUpdateSelfResumeTitle: '是否更新自身简历？',
    similarCandidate: 'AI人才镜像'
  },
  tabMenu: {
    RESUME: '简历',
    REFERRAL_CHAIN: '推荐链',
    OPEN_QUESTION: '筛选',
    ASSESSMENT: '测评',
    INTERVIEW: '面试',
    ONBOARDING: '入职',
    ACTIVITY_TRACKER: '行为',
    TAG: '标签',
    SATISFACTION: '满意度',
    PORTAL: '体验门户',
    OFFER: 'Offer',
    JOB_APPLICATION: '应聘登记表'
  },
  label: {
    professionalMemberShip: '社团组织成员',
    professionalMemberShipInfo: '请列举您参与的任何专业机构或组织',
    awards: '奖励信息',
    awardsInfo: '请列出您所赢得的任何奖项和荣誉',
    hobbies: '兴趣爱好',
    hobbiesInfo: '请列举您想要分享的任何兴趣爱好',
    stepName: {
      UPLOAD_RESUME: '上传简历',
      BASE_INFO: '基本信息',
      MINI_BASE_INFO: '简历',
      DUPLICATE_CANDIDATE: '重复候选人',
      EDUCATION: '教育背景',
      WORK_EXPERIENCE: '工作经验',
      LANGUAGE: '语言能力',
      ADDITIONAL_INFO: '附加信息',
      DESCRIPTION: '求职者描述',
      PRESCREEN_QUESTIONNAIRE: '申请人前置问卷',
      JOB_QUESTIONNAIRE: '申请问卷',
      INVITE_QUESTIONNAIRE: '额外问题',
      HR_QUESTIONNAIRE: '招聘人员筛选',
      ONBOARDING_QUESTIONNAIRE: '入职问卷答复',
      SUBMIT_REFERRAL: '提交/上传简历',
      RESUME_INFO: '预览简历'
    },
    addCandidateTo: '上传到职位 ',
    selectCandidate: '请选择一个职位',
    emailAddress: '电子邮件',
    firstName: '名',
    lastName: '姓',
    candidateId: '求职者 ID',
    salutation: '称谓',
    employeeId: '员工 ID',
    Mr: '先生',
    Mrs: '夫人',
    Ms: '女士',
    gender: '性别',
    birthday: '出生日期',
    photo: '照片',
    homeLocation: '户口所在地',
    country: '户口所在国家 / 地区',
    province: '户口所在省',
    city: '户口所在市',
    currentLocation: '当前所在地',
    currentCountry: '国家 / 地区',
    currentProvince: '省 / 州',
    currentCity: '市 / 镇',
    address: '地址',
    otherAddressIfHave: '其他地址（如果有）',
    otherAddress: '其他地址',
    mobile: '手机号码',
    secondPhone: '其他手机号码',
    chatId: '在线聊天工具',
    socialNetwork: '社交网络',
    personalStatement: '个人陈述',
    expectedSalary: '期望薪资',
    expectedAddress: '期望工作地点',
    show: '显示',
    notShow: '不显示',
    source: '追踪代码名称',
    code: '追踪代码明细 ',
    comment: '评论',
    isPrivate: '仅我可见',
    interviewerCanView: '面试官',
    myComment: '我的评论',
    tag: {
      smart: '智能标签',
      manual: '求职者标签'
    },
    tillNow: '至今',
    idNumber: '身份证号',
    onboardDate: '预计上岗时间',
    hiredDate: '雇用日期',
    required: '必填',
    agree: '同意',
    question: '问题: ',
    onlyTalentPool: '只添加到人才库',
    duplicateCandidate: {
      id: 'ID',
      name: '姓名',
      phone: '手机',
      email: '邮箱'
    },
    educationLevel: '教育背景',
    major: '专业',
    degreeAndMajor: '学历和专业',
    notMajorInfo: '专业不在列表中？',
    majorInput: '不在列表的在这里输入',
    startAndEndDate: '起止时间',
    endDateVerify: '结束时间应该晚于开始时间',
    startDate: '开始时间',
    endDate: '结束时间',
    endDateInfo: '预计毕业日期',
    school: '学校',
    notSchool: '学校不在列表中？',
    academicRating: '学习排名',
    gpa: '平均绩点',
    gpaInfo: '请输入平均绩点 （GPA）',
    summary: '总结',
    summaryInfo: '使用这项与我们分享更多关于您的教育背景. 您获得了什么成就?您最喜欢的专业是什么? 为什么喜欢?您参加过什么特别的项目?您是什么俱乐部或者社团成员吗?有承担什么职责?',
    language: '语言',
    level: '水平',
    certification: '认证',
    score: '分数',
    fileName: '文件名',
    startTime: '创建时间',
    finishTime: '完成时间',
    status: '状态',
    browserFiles: '点击浏览文件',
    reupload: '重新上传',
    jobTitle: '职位名称',
    companyName: '公司名称',
    industry: '行业',
    location: '地址',
    workCountry: '国家 / 地区',
    workProvince: '省 / 州',
    workCity: '市 / 镇',
    salary: '薪资',
    salaryInfo: '税后月薪（人民币）',
    jobFamily: '相关职位',
    description: '职务描述',
    descriptionInfo: '使用这项与我们分享更多关于您的工作经验.您承担过哪些职责?获取了哪些成就?您从中学到了什么?您是怎样发展自己的?',
    applicationChannel: '申请职位渠道',
    jobApplicationPlat: '申请职位平台',
    referrer: '推荐人',
    referralChain: '推荐链',
    date: '日期 ',
    consentStatus: '协议同意情况',
    consentUpdatedTime: '日期',
    consentInfo: '协议',
    candidateStatus: '求职者状态',
    cause: '原因',
    job: '职位',
    comments: '评论',
    activitySource: '追踪代码名称',
    activity: '行为',
    recruiter: '招聘人员',
    hiringManagerNames: '招聘经理',
    candidateNames: '候选人',
    candidateName: '候选人姓名',
    action: '操作',
    ratingCompletion: '完成度',
    ratingCompletionNumber: '完成度：{completion}%',
    hmRatingResult: '评分结果',
    hmInterviewResult: '面试结果',
    questionNumber: '问题 {number}:',
    weighting: '权重 {value}%',
    scale: '分制',
    overall: '总体',
    interview: '面试',
    interviewSequence: '面试 {number}',
    rating: '评估',
    ratingSequence: '评估 {number}',
    hmEvaluationQuestionType: {
      rating: '评分',
      text: '文本',
      singleSelect: '单选',
      multiSelect: '多选',
      date: '日期'
    },
    PENDING: '待评估',
    FINISHED: '已评估',
    SCHEDULED: '已预约',
    CANCELED: '已被取消',
    CANCELED_BY_ORGANIZER: '组织者取消',
    PENDING_CANDIDATE_SELECT_TIME: '待候选人选择时间',
    PENDING_HM_SELECT_TIME: '待面试官选择时间',
    PARTIAL_CANCELED_BY_INTERVIEWER: '面试官取消',
    RESCHEDULING_BY_CANDIDATE: '候选人重新预约',
    RESCHEDULING_BY_INTERVIEWER: '面试官重新预约',
    PENDING_GENERATE_TEAMS_URL: '待生成Teams链接',
    PENDING_GENERATE_TEAMS_EVENT: '待生成Teams事件',
    CANCELED_BY_CANDIDATE: '候选人取消',
    CANCELED_BY_INTERVIEWER: '面试官取消',
    PARTIALLY_RATED: '部分评估',
    RECOMMENDED: '推荐',
    RATE_PENDING: '待定',
    NOT_RECOMMENDED: '不推荐',
    NO_RECOMMENDATION: '无推荐建议',
    SPLIT_DECISION: '分歧',
    NOT_YET_RATE: '待评估',
    video: '视频',
    note: '备注',
    questionnaireQuestion: '问题',
    answer: '选项',
    parentQuestion: '父问题',
    triggerOption: '触发选项',
    tree: {
      selected: '选择',
      answered: '回答'
    },
    age: '年龄',
    appliedDate: '申请日期',
    appliedDays: '已申请{duration}天',
    appliedHours: '已申请{duration}小时',
    appliedTimes: '第{times}次申请',
    appliedJob: '申请',
    resumeFit: '总体匹配度',
    cultureFit: '公司文化匹配度',
    personalityFit: '职业性格匹配度',
    problemSolvingFit: '问题解决能力',
    now: '现在',
    dates: {
      years: '{num} 年',
      months: '{num} 月',
      days: '{num} 天',
      year: '{num} 年',
      month: '{num} 月',
      day: '{num} 天'
    },
    validationInfo: '有效信息',
    employeeStatus: '员工审核状态',
    employee: '员工',
    nonEmployee: '非员工',
    mobileId: '手机帐号',
    name: '姓名',
    email: '邮箱',
    referralReason: '推荐原因',
    referralStatusPending: '待定',
    referralStatusApproved: '已审核',
    referralStatusRejected: '已拒绝',
    notUploadedByHr: '视频未上传',
    videoNotUploaded: '等待求职者回复',
    candidate: '求职者',
    noMobile: '未填写手机',
    noEmail: '未填写邮箱',
    invitationTime: '邀请时间',
    applicationFormReactivateReason: '重新邀请原因：',
    interviewDate: '面试时间',
    interviewTime: '{startTime}到{endTime}',
    interviewDay: '{weekday}， {year}年{month}{day}',
    interviewStatus: '面试状态',
    agreement: {
      agree: '已同意',
      disAgree: '未同意'
    },
    operation: '操作',
    fromGroup: '从分组',
    toGroup: '到分组',
    notificationFrequency: '职位提醒推送频率',
    notificationChannel: '职位提醒推送方式',
    notification: {
      never: '关闭',
      weekly: '每周',
      monthly: '每月',
      email: '邮件',
      wechat: '微信',
      both: '微信和邮件'
    },
    highestDegree: '最高学历',
    updateMobilePhone: '修改手机号码',
    inviteSuccess: '邀请成功',
    resumePath: '查看原始简历',
    emailSubject: '邮件标题',
    yearsOld: '{age}岁',
    workExperienceFit: '工作经历匹配度 (BETA)',
    consentVersion: '协议版本',
    consentVersionCode: '版',
    entity: '公司',
    upcomingInterview: '即将到来的面试',
    interviewResultsPending: '面试结果待定',
    completedInterviews: '已完成的面试',
    asOfCurrent: '截止至{currentTime}',
    inviteCandidateToInterview: '邀请候选人参加面试',
    today: '今天',
    switchMiniResume: '基本信息',
    switchFullResume: '详细简历',
    consentLinkTitle: '复制收集协议同意链接发送给候选人',
    consentLinkLabel: '链接',
    consentQrCodeTile: '生成收集协议同意二维码发送给候选人',
    consentQrCodeLabel: '二维码',
    consentSendTitle: '您需要发送一封系统收集协议同意邮件和短信给候选人吗？',
    interviewReport: '面试报告',
    questions: '问题',
    clickToView: '点击查看',
    aiInterviewTime: 'AI面试时间',
    overallScore: '总分',
    copiedFrom: '复制于：',
    rateDate: '邀请时间',
    screen: '筛选',
    activityTracker: '行为',
    screening: '筛选',
    collapseQuestion: '问题',
    collapseAnswer: '选项',
    collapseVideo: '视频',
    collapseNote: '备注',
    elcQuestionQRCodeTip: '请通过手机扫码完成该申请的开放性问题，您可能会被要求登陆您的账号。',
    partTimeExperience: '实习兼职经验',
    workExperience: '工作经验',
    or: '或',
    thirdType: '当前网站',
    experience: '工作经验',
    education: '教育背景',
    importResumeTip: '快速导入您在其他网站上的简历：',
    preferenceTip: '上传/提交您的简历，获取更多关注！',
    degreeLevel: '学历',
    to: '至',
    hasDuplicateCandidate: '您上传的候选人可能是重复候选人，请尽快联系对应的招聘专员，',
    duplicateTalentCandidatePrevTip: '该候选人已存在于人才库中，',
    duplicateTalentCandidateToView: '点击这里',
    duplicateTalentCandidateEndTip: '查看。',
    countryCode: '区号',
    aiQuestions: '问题:',
    answers: '答案:',
    interviewResult: '面试结果',
    ashbyCandidateProfileUrl: 'Ashby 简历链接',
    viewAshbyCandidateProfile: '查看',
    appliedJobsTotalLabel: '总申请数: ',
    otherAppliedJobsLabel: '最近的申请: ',
    organizer: '组织者',
    interviewers: '面试官',
    applicationFormInvitationTime: '最近邀请时间：',
    applicationFormFinishedTime: '最近完成时间：',
    applicationFormStatus: '状态：',
    applicationFormCandidateName: '求职者姓名：',
    applicationFormDate: '日期：'
  },
  placeholder: {
    professionalMemberShip: '请列举您参与的任何专业机构或组织',
    awards: '请列出您所赢得的任何奖项和荣誉',
    hobbies: '请列举您想要分享的任何兴趣爱好',
    uploadFileDescription: '描述',
    keywordSearch: '关键字',
    allStatus: '所有状态',
    input: '请输入',
    select: '请选择',
    startDate: '开始日期',
    endDate: '结束日期',
    selectDate: '请选择日期',
    major: '输入并选择专业, 如果不存在则直接输入即可',
    school: '输入并选择学校, 如果不存在则直接输入即可',
    inputAndSelect: '点击输入然后选择',
    videoDescription: '点击这里输入你的视频作答的备注…',
    fileDescription: '点击这里输入你的附件作答的备注…',
    pleaseStartTyping: '请开始输入',
    currentDate: '今'
  },
  btn: {
    reset: '重置',
    confirm: '确定',
    addTag: '添加标签',
    personalStatementInfoDescription: '请用几句话概括您的优势和您适合这个工作机会的主要原因',
    expectedSalaryInfo: '税后月薪（人民币）',
    addLocation: '添加地址',
    addChatTool: '添加聊天工具',
    deleteChatTool: '删除这条聊天工具',
    addSocialNetwork: '添加社交网站',
    deleteSocialNetwork: '删除这条社交网站',
    selectPhoto: '选择文件',
    upload: {
      selectFile: '选择文件',
      selectAnotherFile: '重新选择'
    },
    viewDuplicateCandidate: '查看',
    addEducationBackground: '增加教育背景 （从最高学历填起）',
    editor: '编辑',
    delete: '删除',
    addLanguage: '增加语言',
    backJobList: '查看职位列表',
    backApplicantList: '返回求职者列表',
    viewHistory: '查看上传历史',
    openUploader: '批量添加求职者',
    startUpload: '开始上传',
    viewCandidate: '查看求职者',
    addPartTimeExperience: '增加实习兼职经验',
    addWorkExperience: '增加工作经验',
    addComment: '评论',
    cancel: '取消',
    reschedule: '重新预约',
    sendInterviewRating: '再次发送面试评估链接',
    viewGroupInterview: '查看小组面试详情',
    more: '更多',
    scheduleAnotherInterview: '预约进一步面试',
    interviewConfirm: '面试确认',
    inviteApplyJob: '邀请申请职位',
    inviteFinishProfile: '邀请完善简历',
    exportPDF: '导出PDF',
    share: '分享',
    contact: '联系',
    editResume: '编辑',
    editOpenQuestion: '招聘人员筛选问题',
    copyCandidate: '复制',
    group: '分组',
    inviteAnswerQuestion: '向候选人发送筛选问题',
    hiringManagerRating: '向招聘经理发送简历评估',
    hiringManagerInterview: '发送面试邀请',
    startInterview: '开始面试',
    startRating: '开始评估',
    viewReport: '查看报告',
    inviteValueAndStrengthLabel: '邀请做价值观&优势测评',
    inviteProblemSolveLabel: '邀请做问题解决能力测评',
    inviteOnboarding: '邀请填写入职问卷',
    invitedAndResent: '已邀请于 {date}（重发邀请）',
    invited: '已邀请于{date}',
    invitePostApplicant: '向候选人发送门户邀请',
    inviteSatisfactionSurvey: '向候选人发送满意度调查',
    addGroup: '增添...',
    moveGroup: '移动到...',
    reject: '拒绝',
    moveForward: '进入下一阶段',
    updateMobilePhone: '修改手机号码',
    inviteNoFinishedOpenQuestion: '还没有回答问题，再次发送邀请',
    resume: '简历',
    report: '报告',
    resumeAndReport: '简历和报告',
    exportConsentInfo: '协议同意状况',
    agencyUploadedCandidate: {
      accept: '同意',
      reject: '拒绝',
      rejected: '已拒绝'
    },
    exportConsentPDF: '导出同意情况PDF',
    exportWord: '导出Word',
    inviteAnswerORQuestion: '邀请回答OR问卷',
    revokeApplication: '删除此条申请',
    revokeAllApplication: '删除该候选人所有数据',
    viewResume: '查看简历',
    viewProfile: '查看信息',
    exportOriginResume: '导出原始简历',
    exportAjingaProfilePDF: '导出AJINGA模板PDF',
    inviteAgreeConsent: '发送收集协议同意邮件和短信',
    inviteAgreeConsentByLink: '复制收集协议同意链接',
    inviteAgreeConsentQrCode: '生成收集协议同意二维码',
    inviteUploadResume: '邀请上传简历文件',
    confirmInviteUploadResumeContent: '发送邮件邀请候选人上传他们的最新简历',
    inviteUploadResumeResent: '已邀请于 {date}（重发邀请上传简历）',
    inviteUploadResumeUpdate: '简历已上传，再次邀请',
    inviteAiInterview: '邀请AI面试',
    inviteAiInterviewResent: '已邀请于 {date}（重发邀请AI面试）',
    hasInviteAIInterview: '已邀请AI面试于 {date}',
    cancelSendInviteUpload: '返回',
    confirmSendInviteUpload: '发送',
    confirmInviteUploadResumeTip: '发送邮件邀请候选人上传他们的最新简历',
    createAISummary: 'AI简历提炼',
    viewAISummary: '查看/编辑AI简历提炼',
    aiResumeSummarizerCopy: '复制AI简历提炼',
    createAIResumeMatch: 'AI匹配度',
    resendHmRating: '重新向招聘经理发送简历评估',
    inviteJobApplication: '邀请应聘登记',
    remindJobApplication: '发送提醒',
    resendJobApplication: '已邀请于 {time}',
    reactivatedJobApplication: '重新激活于 {time}',
    backToResume: '返回简历',
    downloadJobApplicationPDF: '下载PDF',
    reactivateJobApplication: '重新激活',
    save: '保存',
    createNewResume: '创建一个新的简历',
    ios: 'iOS / iCloud',
    android: 'Android',
    harmony: 'Harmony',
    photo: 'Photo',
    uploadResume: '上传简历',
    importJob51: '导入前程无忧简历',
    importJobStreet: '导入求职工作街简历',
    job51: '前程无忧',
    jobStreet: '求职工作街',
    editProfile: '使用我的已有简历',
    clear: '清除',
    sendOfferLetter: '发放Offer',
    sendOfferLetterNotice: '发送提醒',
    resendOfferLetterNotice: '发送提醒',
    reSendInviteOfferLetter: '重发Offer',
    exportOfferPdf: '导出',
    sendOffer: '发放',
    inviteAIInterview: '邀请AI面试',
    skip: '跳过',
    summaryViewResume: '查看简历',
    sendAIInterviewReminder: '发送AI面试提醒'
  },
  message: {
    refreshPageWithoutSaveData: '请点击确定离开页面，您输入的信息会丢失。\n请点击取消继续留在这个页面。',
    select: '请选择',
    wrongPhotoFileType: '请确认图片是以下类型: jpeg, jpg, png',
    startDateAfterEndDate: '结束时间应该晚于开始时间',
    gpaDataValueError: '平均绩点应大于等于0，小于等于4',
    questionVideoIsTooLong: '视频长度超过{duration}',
    requiredQuestionAnswer: '这是一个必填问题, 请选择或者填写你的答案',
    wrongFileType: '请检查选择的文件类型',
    wrongFileSize: '请检查选择的文件大小',
    uploadTip: {
      waitUploaded: '请等待文件上传完毕',
      openQuestionVideo: '建议上传{duration}以内，mp4，mov，ogg，avi格式的视频',
      attachment: '允许最大{size}MB。请注意上传过程根据您当前的网络情况可能需要4到6分钟完成。',
      videoUploadTips: '点击按钮现在录制或者上传你的视频。\n你也可以先收藏此页面，等到你完成视频的录制后再来上传。',
      videoUploadTipsPC: '点击按钮上传你的视频。\n你也可以先收藏此页面，等到你完成视频的录制后再来上传。',
      videoUploadTipsForELC: '点击按钮现在录制你的视频。\n你也可以先收藏此页面，等到你准备好后再来录制。'
    },
    sourceTips: '不是所有的用户都能新建追踪代码名称，如果你无法看到你想用的追踪代码名称也不能新建，请联系你的菁客客户经理或者邮件联系service@ajinga.com',
    sourcePlaceholder: '例如Job Fair或者Hiring Campaign等，建议用英文',
    codeTips: '不是所有的用户都能新建追踪代码明细，如果你无法看到你想用的追踪代码明细也不能新建，请联系你的菁客客户经理或者邮件联系service@ajinga.com',
    codePlaceholder: '例如招聘会日期，活动名称等，建议用英文',
    needOneOfEmailOrMobile: '请至少填写候选人邮箱或者手机号其中之一',
    isHrEmailOrPhone: '该账号为公司用户，无法上传。请联系service@ajinga.com获取更多帮助。',
    hasUploadedInTalentPool: '该候选人已存在于公司人才库中，请勿重复上传！',
    educationRequired: '请选择教育背景',
    majorRequired: '请选择专业',
    startDateRequired: '请选择开始日期',
    endDateRequired: '请选择结束日期（预计毕业日期）',
    schoolRequired: '请选择学校',
    educationCountRequired: '至少要有一条教育经历',
    dropTip: '拖拽简历到此处',
    or: '或',
    uploadTips: [
      '只能上传10MB以内的简历',
      "支持以下格式：'pdf', 'doc', 'docx, 'shtml', 'html', 'png', 'jpg', 'jpeg' 和 'bmp'"
    ],
    noSelectedFile: '还没有选择任何文件',
    uploadingTip: '文件正在上传中，请勿关闭该页面',
    uploadedTip: '文件上传已结束，你可以安全的关闭该页面。简历的处理稍后将会自动开始',
    noUploadingFile: '暂时没有正在上传的文件',
    leavePageTip: '确定离开该页面？仍然存在正在上传的文件！',
    fileCountLimit: '单次上传只能添加{count}个文件',
    fileSizeLimit: '单次文件大小不能超过{size}MB',
    uploadFinished: '上传完成',
    companyNameRequired: '请输入公司名称',
    jobTitleRequired: '请输入职位名称',
    industryRequired: '请选择相关职位',
    jobFamilyRequired: '请选择行业',
    countryRequired: '请选择国家 / 地区',
    provinceRequired: '请选择省 / 州',
    cityRequired: '请选择市 / 镇',
    startTimeRequired: '请选择开始时间',
    workCountRequired: '至少要有一条工作经验',
    interCountRequired: '至少要有一条实习经历',
    saveQuestionSuccess: '保存成功',
    addCommentSuccess: '添加成功',
    addCommentFail: '添加评论失败',
    inviteFinishProfile: {
      success: '邀请成功',
      noEmailAccount: '该用户没有填写邮箱，我们暂时无法邀请该求职者。短信邀请正在紧张制作中，敬请期待！',
      hasFinished: '该用户已完成简历填写，无需邀请',
      fail: '邀请失败'
    },
    inviteFinishAssessment: {
      success: '邀请成功',
      noEmailAccount: '该用户没有填写邮箱，我们暂时无法邀请该求职者。短信邀请正在紧张制作中，敬请期待！',
      hasFinished: '该用户已完成测评填写，无需邀请',
      fail: '邀请失败'
    },
    emailHasAlreadyUsed: '该邮箱已经被使用，请更换邮箱地址！',
    fieldRequired: '请展开并完成红色部分信息。',
    cannotCancelInterviewDueToDeadline: '您的面试邀请无法取消因预约的面试时间已过。',
    cannotCancelInterviewHasBeenRated: '您的面试邀请无法取消因其他招聘经理已提交此面试评估。',
    confirmToCancelInterview: '您确定要取消此面试预约吗？',
    inviteORQuestion: '您已选择{inviteCount}人发送邀请，{successCount}人已邀请成功。',
    revokeApplicationConfirmTip: '确认删除此条申请？',
    revokeAllApplicationConfirmTip: '确认删除该候选人所有数据？',
    headhunterUploadSuccess: '您已完成候选人的简历上传。请您提醒候选人查阅系统发送的邮件，完成个人信息授权。届时您的推荐将完成。感谢您的支持！',
    noData: '没有更多的数据了',
    inviteAgreeConsent: {
      success: '邮件和短信发送成功',
      copySuccess: '链接复制成功，您可以粘贴分享给候选人了'
    },
    uploadResumeTips: '该职位要求上传简历',
    cannotCancelMicrosoftMeeting: '该面试记录中的会议需要先登录微软账号，才能取消面试',
    cvOwner: '简历拥有者: {name}',
    inviteCandidateUploadSuccess: '邀请成功',
    aiSummaryCopySuccess: '复制成功',
    addToGenerateTaskSuccessful: '请稍后，我们正在计算匹配度分数。谢谢！',
    beforeData: '该日期必须早于 {beforeDate}',
    afterDate: '该日期必须晚于 {afterDate}',
    resetEndDate: '结束日期必须晚于该日期',
    pendingUpload: '等待上传',
    endDate: '至今',
    uploadSuccess: '上传成功',
    processQuestionAnswer: '计算中，请稍后查看',
    uploadVideoSuccess: '上传成功',
    uploadVideoFail: '上传失败，请稍后再试!',
    canNotInviteSatisfactionSurvey: '无法发送满意度调查，因为该候选人尚未同意隐私政策。',
    sendOfferNoticeSuccess: '发送成功',
    inviteOfferSuccess: '邀请成功',
    reInviteOfferSuccess: '重发Offer成功',
    hasDuplicateCandidate: '您上传的候选人可能是重复候选人，请尽快联系对应的招聘专员。',
    deleteSuccess: '删除成功',
    disabledTip: '您没有权限管理此职位的候选人。',
    remindJobApplicationSuccess: '提醒已发送',
    reactivateTitle: '确认重新激活',
    reactivateReasonLabel: '重新激活原因（可选）',
    reactivateReason: '请输入重新激活原因（可选）',
    reactivateSuccess: '重新激活成功',
    reactivateFailed: '重新激活失败',
    jobAIInterviewRoomError: '职位需要配置面试间',
    jobAIInterviewRoomErrorContent: "点击'选择'去创建面试间",
    inviteAIInterviewSuccess: '邀请成功',
    sendAIInterviewReminderSuccess: '发送成功',
    aiParseResumeError: 'AI解析简历异常，请稍后再试',
    parseResumeError: '解析简历异常，请稍后再试',
    aiParseResumeTimeout: 'AI解析简历超时，请稍后再试'
  },
  questionType: {
    TEXT: '问答',
    TEXTAREA: '问答',
    SELECT: '单选',
    RADIO: '单选',
    CHECKBOX: '多选',
    DATE: '日期',
    VIDEO: '视频',
    ATTACHMENT: '附件',
    POLICY: '协议'
  },
  fileUpload: {
    empty: '待上传',
    uploading: '上传中',
    uploaded: '已上传'
  },
  editor: {
    addChatTool: '添加聊天工具',
    deleteChatTool: '删除这条聊天工具',
    addSocialNetwork: '添加社交网站',
    deleteSocialNetwork: '删除这条社交网站',
    education: {
      title: {
        addEducation: '增加教育背景',
        deleteEducation: '删除这条教育背景',
        editEducation: '编辑教育背景'
      },
      message: {
        schoolRequired: '请选择学校',
        educationRequired: '请选择教育背景',
        educationCountRequired: '至少要有一条教育经历'
      }
    },
    language: {
      title: {
        addLanguages: '增加语言',
        deleteLanguages: '删除这条语言',
        editorLanguages: '编辑语言'
      }
    },
    workExperience: {
      title: {
        addWorkExperience: '增加工作经验',
        deleteWorkExperience: '删除这条工作经验',
        editorWorkExperience: '编辑工作经验'
      }
    },
    partTimeExperience: {
      title: {
        addWorkExperience: '增加实习兼职经验',
        deleteWorkExperience: '删除这条实习兼职经验',
        editorWorkExperience: '编辑实习兼职经验'
      }
    }
  },
  tip: {
    uploadVideo: '点击按钮上传你的视频',
    uploadVideoInfo: '你也可以先收藏此页面，等到你完成视频的录制后再来上传。建议上传30s以内，MP4，mov，ogg，avi格式的视频',
    uploadAttachment: '点击上传附件',
    uploadAttachmentInfo: '允许文件最大200MB。请注意上传过程根据您当前的网络情况可能需要4到6分钟完成。',
    resumeFitInfo: 'AJINGA人工智能简历匹配分数是将职位描述与候选人的工作经历进行比较计算得出的。AI分数匹配只能对统一语言的职位描述和简历进行打分。比如英文职位描述与英语简历，或者中文职位描述与中文简历之间进行匹配。此功能目前为BETA版本。我们欢迎您的反馈并支持您联系AJINGA顾问提出问题或改进建议。'
  },
  openQuestionContainerType: {
    PRESCREEN: '申请人前置问卷',
    NORMAL: '申请人调查问卷',
    SPECIFIC: '特定问题',
    HR: '招聘人员筛选'
  },
  containerTitle: {
    uploadHistory: '上传历史',
    selectedFiles: '已选择的文件',
    uploadStatus: '文件正在上传中，请勿关闭该页面...'
  },
  taskStatus: {
    FAILED: '失败',
    FINISHED: '成功',
    APPLICATION_EXISTED: '重复添加',
    WAITING: '处理中',
    UPLOADING: '上传中'
  },
  jobApplicationPlat: {
    emailResume: {
      'www.51job.com': '前程无忧',
      'www.zhaopin.com': '智联招聘',
      'www.58.com': '58同城',
      'www.61hr.com': '61HR',
      'www.veryeast.cn': '最佳东方',
      'www.ganji.com': '赶集',
      'www.linkedin.com': '领英',
      'www.liepin.com': '猎聘',
      'www.wotui.com': '我推',
      'gikoo.cn': '捷库',
      'yingjiesheng.com': '应届生求职网',
      'shixiseng.com': '实习僧',
      'www.jobsdb.com': 'JobsDB',
      'JobStreet.com': 'JobStreet.com',
      'jianzhimao.com': '兼职猫',
      Others: '菁客'
    },
    candidateUpload: '供应商简历上传',
    uploadByAgency: '猎头上传简历',
    aspireProgram: 'Aspire Program',
    submittedReferral: '提交的推荐简历',
    workday: 'Workday',
    ajinga: '菁客'
  },
  ACADEMIC_RATING: {
    TOP5: '排名前 5%',
    TOP10: '排名前 10%',
    TOP20: '排名前 20%',
    TOP30: '排名前 30%',
    OTHER: '其他'
  },
  STATUS_GROUP: {
    APPLY: '申请',
    SCREEN: '筛选',
    INTERVIEW: '面试',
    OFFER: 'Offer',
    HIRED: '雇用'
  },
  consentStatusType: {
    Agreed: '同意',
    Rejected: '拒绝',
    Pending: '待同意'
  },
  AI_PARSE_TASK_STATUS: {
    START: 'AJINGA 智能 AI 正在解析您上传的简历文件。',
    REVIEW: 'AJINGA 智能 AI 正在审核您的简历文件...',
    READING: 'AJINGA 智能 AI 正在阅读您的简历文件...',
    EXTRACTION: 'AJINGA 智能 AI 正在提取您的简历文件信息...',
    FORMATING: 'AJINGA 智能 AI 正在格式化提取信息...',
    WRITING: 'AJINGA 智能 AI 即将完成您的简历文件解析...'
  }
}
